import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirTreasureHuntSettings() {
  const el = document.querySelector('[data-config]');
  let initial = {};
  try {
    initial = JSON.parse(el?.getAttribute('data-config') || '{}');
  } catch (_) {
    initial = {};
  }

  return {
    loading: false,
    saving: false,
    form: {
      enabled: true,
      coins_weight: 70,
      coins_amount: 50,
      xp_amount: 50,
      voucher_weight: 30,
      voucher_type: 'fixed',
      voucher_discount_value: 5000,
      voucher_min_transaction: 25000,
      voucher_max_use: 1,
      voucher_max_use_per_user: 1,
      voucher_expires_days: 7,
      voucher_name: 'Voucher Treasure Hunt INKO',
    },

    get chanceCoins() {
      const t = Math.max(1, Number(this.form.coins_weight || 0) + Number(this.form.voucher_weight || 0));
      return Math.round((Number(this.form.coins_weight || 0) / t) * 1000) / 10;
    },
    get chanceVoucher() {
      const t = Math.max(1, Number(this.form.coins_weight || 0) + Number(this.form.voucher_weight || 0));
      return Math.round((Number(this.form.voucher_weight || 0) / t) * 1000) / 10;
    },

    init() {
      this.applyForm(initial);
      this.refresh();
    },

    applyForm(d) {
      if (!d || typeof d !== 'object') return;
      this.form = {
        enabled: !!d.enabled,
        coins_weight: Number(d.coins_weight ?? 70),
        coins_amount: Number(d.coins_amount ?? 50),
        xp_amount: Number(d.xp_amount ?? 50),
        voucher_weight: Number(d.voucher_weight ?? 30),
        voucher_type: d.voucher_type || 'fixed',
        voucher_discount_value: Number(d.voucher_discount_value ?? 5000),
        voucher_min_transaction: Number(d.voucher_min_transaction ?? 25000),
        voucher_max_use: Number(d.voucher_max_use ?? 1),
        voucher_max_use_per_user: Number(d.voucher_max_use_per_user ?? 1),
        voucher_expires_days: Number(d.voucher_expires_days ?? 7),
        voucher_name: d.voucher_name || 'Voucher Treasure Hunt INKO',
      };
    },

    async refresh() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/v1/kasir/engagement/treasure-hunt-settings');
        this.applyForm(data.data || {});
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat pengaturan.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async save() {
      if (this.saving) return;
      this.saving = true;
      try {
        const { data } = await axios.put('/api/v1/kasir/engagement/treasure-hunt-settings', this.form);
        this.applyForm(data.data || {});
        window.toast?.(data.message || 'Pengaturan disimpan.', 'success');
      } catch (e) {
        const msg = e.response?.data?.message
          || Object.values(e.response?.data?.errors || {})?.[0]?.[0]
          || 'Gagal menyimpan.';
        window.toast?.(msg, 'error');
      } finally {
        this.saving = false;
      }
    },
  };
}

Alpine.data('kasirTreasureHuntSettings', createKasirTreasureHuntSettings);
